// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_block_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BiddingBlockService } from "./bidding_block_service_pb";

/**
 * 承認依頼の一覧。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.ListBiddingBlockApprovalRequests
 */
export const listBiddingBlockApprovalRequests = BiddingBlockService.method.listBiddingBlockApprovalRequests;

/**
 * 承認依頼 1 件 + 全 BlockBid (leg) 明細を取得。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.GetBiddingBlockApprovalRequest
 */
export const getBiddingBlockApprovalRequest = BiddingBlockService.method.getBiddingBlockApprovalRequest;

/**
 * 承認依頼を新規作成。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.CreateBiddingBlockApprovalRequest
 */
export const createBiddingBlockApprovalRequest = BiddingBlockService.method.createBiddingBlockApprovalRequest;

/**
 * 下書きの更新。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.UpdateBiddingBlockApprovalRequest
 */
export const updateBiddingBlockApprovalRequest = BiddingBlockService.method.updateBiddingBlockApprovalRequest;

/**
 * 下書きの削除。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.DeleteBiddingBlockApprovalRequest
 */
export const deleteBiddingBlockApprovalRequest = BiddingBlockService.method.deleteBiddingBlockApprovalRequest;

/**
 * 承認ワークフローの状態遷移 (= 承認申請 / 承認 / 差戻し / 申請取消 / JEPX 提出 / 予約取消 を action で指定)。
 * 予約取消 (WITHDRAW) は予約中の札だけ有効 (AC-BSP-092)。
 * 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.TransitionBiddingBlockApprovalState
 */
export const transitionBiddingBlockApprovalState = BiddingBlockService.method.transitionBiddingBlockApprovalState;

/**
 * 入札中のブロック入札グループを入札締切前に取り下げる (AC-BSP-057)。
 * グループ単位 (LINK-P + LINK-C / LOOP-A + LOOP-B は不可分)。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.WithdrawBiddingBlockBidGroup
 */
export const withdrawBiddingBlockBidGroup = BiddingBlockService.method.withdrawBiddingBlockBidGroup;

/**
 * 入札中のブロック入札グループの一括取下 (AC-BSP-116)。 件数の上限は無い。 1 トランザクションでまとめて
 * 全 leg を取下処理中にし、 取下できなかったグループは理由を results に返す。 error 応答ならどのグループも
 * 取り下げていない (通信の失敗では結果不明なので一覧を読み直す)。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.WithdrawBiddingBlockBidGroups
 */
export const withdrawBiddingBlockBidGroups = BiddingBlockService.method.withdrawBiddingBlockBidGroups;

/**
 * ブロック入札 CSV のチェック (= 構文 + 業務検証 + 差分プレビュー、 副作用なし)。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.CheckBiddingBlockCsv
 */
export const checkBiddingBlockCsv = BiddingBlockService.method.checkBiddingBlockCsv;

/**
 * ブロック入札 CSV の確定 (= check_token を引き換えて承認依頼を作成)。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.ApplyBiddingBlockCsv
 */
export const applyBiddingBlockCsv = BiddingBlockService.method.applyBiddingBlockCsv;

/**
 * まとめて承認 (AC-BSP-118)。 件数の上限は無い。 1 トランザクションでまとめて承認し、 承認できなかった
 * 案件は理由を results に返す。 error 応答ならどの案件も承認していない (通信の失敗では結果不明なので
 * 一覧を読み直す。 internalapi の同名 RPC 参照)。
 *
 * @generated from rpc bffuser.v1.BiddingBlockService.ApproveBiddingBlockApprovalRequests
 */
export const approveBiddingBlockApprovalRequests = BiddingBlockService.method.approveBiddingBlockApprovalRequests;

/**
 * @generated from rpc bffuser.v1.BiddingBlockService.CheckBiddingBlockSubmissionDuplicates
 */
export const checkBiddingBlockSubmissionDuplicates = BiddingBlockService.method.checkBiddingBlockSubmissionDuplicates;
